var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefualtAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2519 26.1541C32.0719 23.9741 29.4772 22.3603 26.6461 21.3834C29.6783 19.2951 31.6703 15.8 31.6703 11.848C31.6703 5.4676 26.4794 0.276733 20.0991 0.276733C13.7187 0.276733 8.52785 5.4676 8.52785 11.848C8.52785 15.8 10.5199 19.2951 13.5521 21.3834C10.7211 22.3603 8.1263 23.9741 5.9463 26.1541C2.16595 29.9345 0.0839844 34.9607 0.0839844 40.3069H3.21134C3.21134 30.995 10.7871 23.4192 20.0991 23.4192C29.411 23.4192 36.9868 30.995 36.9868 40.3069H40.1142C40.1142 34.9607 38.0322 29.9345 34.2519 26.1541ZM20.0991 20.2918C15.4431 20.2918 11.6552 16.504 11.6552 11.848C11.6552 7.19195 15.4431 3.40409 20.0991 3.40409C24.755 3.40409 28.543 7.19195 28.543 11.848C28.543 16.504 24.755 20.2918 20.0991 20.2918Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefualtAvatar);
export default __webpack_public_path__ + "static/media/defualtAvatar.3248310a8164d1af0d8a769d44413941.svg";
export { ForwardRef as ReactComponent };